import { render, staticRenderFns } from "./ExternalShareIcon.vue?vue&type=template&id=5e318685&scoped=true"
import script from "./ExternalShareIcon.vue?vue&type=script&lang=js"
export * from "./ExternalShareIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e318685",
  null
  
)

export default component.exports